<template>
  <div class="email-client-vdialog">
    <v-row justify="center" class="pregled-poste-wrapper">
      <v-dialog v-model="dialog" width="1250px" style="overflow-y: hidden; overflow-x: hidden">
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
            Otvori mail
          </v-btn> -->
          <div class="section-square izlazna-posta" v-bind="attrs" v-on="on" @click="addFuckingClass">
            <img class="doc-icon" src="@/assets/img/email_client.svg" />
            <div>E-mail</div>
          </div>
        </template>
        <v-card>
          <div id="email-catcher" class="email-client-header" v-if="selected_attachment == null">
            <div class="header-left-wrapper">
              <div class="case-name email-client-title">E-MAIL</div>
              <div class="posta-dropdown" style="margin-left: 1rem">
                Prikaži:
                <select id="search-group" v-model="selected_type">
                  <option value="0">Sve e-mailove</option>
                  <option value="1" v-if="spisi.length>0">Vezani uz predmet</option>
                </select>
                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
              </div>
            </div>
            <div class="comm-buttons-wrapper">
              <div class="spis-dropdown-wrapper" v-if="spisi.length>0">
                <div :class="[
                  'button-dodijeli-komunikaciji',
                  dropSpisOpen ? 'active' : '',
                ]" @click="openSpisDrop()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                    <g>
                      <g>
                        <path
                          d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z" />
                      </g>
                    </g>
                  </svg>
                  <span class="button-text-span-spis" style="width: 50.95px">{{
                  dodaj_spis_text
                  }}</span>
                  <div class="svg-spin-wrapper-spis" style="
                      display: none;
                      width: 50.95px;
                      justify-content: center;
                    ">
                    <svg class="update-event-spin spinner-spis" id="add-to-spis" style="display: none"
                      viewBox="0 0 50 50">
                      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                    </svg>
                  </div>
                  <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                </div>
                <div class="custom-dropdown-elements-wrapper">
                  <div v-for="spis in spisi" :key="spis.id" class="custom-dropdown-element-wrapper">
                    <div class="custom-dropdown-text">{{ spis.naziv }}</div>
                    <div class="task-checkbox-container" @click="chooseSpis(spis.id)">
                      <div :class="[
                        'custom-checkbox',
                        'popup-check',
                        chosen_spis == spis.id ? 'active' : '',
                      ]">
                        <div class="check"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-add-button" @click="addToSpis()">
                    Dodaj
                  </div>
                </div>
              </div>
              <!-- <div class="posta-dropdown" style="margin-left:1rem;">
                Dodaj spisu
                <select id="search-group" v-model="chosen_spis">
                  <option value="0">Odaberi spis</option>
                  <option v-for="(spis,key) in spisi" :key="key" :value="spis.id">{{spis.naziv}}</option>
                </select>
                <img
                  class="calendar-arrow"
                  src="@/assets/img/strelica_dupla.svg"
                />
              </div> -->
              <div :class="[
                'button-dodijeli-komunikaciji',
                adding_to_ulazna ? 'active' : '',
              ]" @click="!adding_to_ulazna ? inMailToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z"
                    fill="#342DAB" />
                </svg>
                <span class="button-text-span-ulazna" style="width: 58.56px">{{
                dodaj_ulazna_text
                }}</span>
                <div class="svg-spin-wrapper-ulazna" style="display: none; width: 58.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-ulazna" style="display: none"
                    viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                  </svg>
                </div>
              </div>
              <div :class="[
                'button-dodijeli-komunikaciji',
                adding_to_izlazna ? 'active' : '',
              ]" @click="!adding_to_izlazna ? outMailToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z"
                    fill="#342DAB" />
                </svg>
                <span class="button-text-span-izlazna" style="width: 60.26px">{{
                dodaj_izlazna_text
                }}</span>
                <div class="svg-spin-wrapper-izlazna" style="display: none; width: 60.26px; justify-content: center">
                  <svg class="update-event-spin spinner-izlazna" id="add-to-izlazna" style="display: none"
                    viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                  </svg>
                </div>
              </div>

            </div>
          </div>
          <div id="email-catcher" class="email-client-header" v-else>
            <div class="header-left-wrapper">
              <div class="case-name email-client-title">Upravljanje dokumentom {{selected_attachment.name}} </div>
            </div>
            <div class="comm-buttons-wrapper">
              <div class="spis-dropdown-wrapper" v-if="spisi.length>0 && isFilePdf()">

                <div  :class="[
                  'button-dodijeli-komunikaciji',
                  dropSpisOpen ? 'active' : '',
                ]" @click="openSpisDrop()" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                    <g>
                      <g>
                        <path
                          d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z" />
                      </g>
                    </g>
                  </svg>
                  <span class="button-text-span-spis" style="width: 50.95px">{{
                  dodaj_spis_text
                  }}</span>
                  <div class="svg-spin-wrapper-spis" style="
                      display: none;
                      width: 50.95px;
                      justify-content: center;
                    ">
                    <svg class="update-event-spin spinner-spis" id="add-to-spis" style="display: none"
                      viewBox="0 0 50 50">
                      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                    </svg>
                  </div>
                  <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
                </div>
                <div class="custom-dropdown-elements-wrapper">
                  <div v-for="spis in spisi" :key="spis.id" class="custom-dropdown-element-wrapper">
                    <div class="custom-dropdown-text">{{ spis.naziv }}</div>
                    <div class="task-checkbox-container" @click="chooseSpis(spis.id)">
                      <div :class="[
                        'custom-checkbox',
                        'popup-check',
                        chosen_spis == spis.id ? 'active' : '',
                      ]">
                        <div class="check"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-add-button" @click="addAttachmentToSpis()">
                    Dodaj
                  </div>
                </div>
              </div>
              <!-- <div class="posta-dropdown" style="margin-left:1rem;">
                Dodaj spisu
                <select id="search-group" v-model="chosen_spis">
                  <option value="0">Odaberi spis</option>
                  <option v-for="(spis,key) in spisi" :key="key" :value="spis.id">{{spis.naziv}}</option>
                </select>
                <img
                  class="calendar-arrow"
                  src="@/assets/img/strelica_dupla.svg"
                />
              </div> -->
              <div v-if="isFilePdf()" :class="[
                'button-dodijeli-komunikaciji',
                adding_to_ulazna ? 'active' : '',
              ]" @click="!adding_to_ulazna ? inAttachmentToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z"
                    fill="#342DAB" />
                </svg>
                <span class="button-text-span-ulazna" style="width: 58.56px">{{
                dodaj_ulazna_text
                }}</span>
                <div class="svg-spin-wrapper-ulazna" style="display: none; width: 58.56px; justify-content: center">
                  <svg class="update-event-spin spinner-ulazna" id="add-to-ulazna" style="display: none"
                    viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                  </svg>
                </div>
              </div>
              <div v-if="isFilePdf()" :class="[
                'button-dodijeli-komunikaciji',
                adding_to_izlazna ? 'active' : '',
              ]" @click="!adding_to_izlazna ? outAttachmentToPDF() : ''">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.1888 0H5.03412C4.58608 0 4.22284 0.374616 4.22284 0.836705V3.10904C4.22284 3.57113 4.58608 3.94575 5.03412 3.94575C5.48217 3.94575 5.8454 3.57113 5.8454 3.10904V1.67341H24.3774V17.3219H5.8454V15.8863C5.8454 15.4242 5.48217 15.0496 5.03412 15.0496C4.58608 15.0496 4.22284 15.4242 4.22284 15.8863V18.1586C4.22284 18.6207 4.58608 18.9953 5.03412 18.9953H25.1887C25.6368 18.9953 26 18.6207 26 18.1586V0.836705C26.0001 0.37454 25.6368 0 25.1888 0ZM2.76183 7.32891H6.24029C6.68834 7.32891 7.05157 6.95429 7.05157 6.4922C7.05157 6.03011 6.68834 5.6555 6.24029 5.6555H2.76183C2.31378 5.6555 1.95055 6.03011 1.95055 6.4922C1.95055 6.95429 2.31378 7.32891 2.76183 7.32891ZM6.24028 10.3344H0.811279C0.363232 10.3344 0 9.95977 0 9.49769C0 9.0356 0.363232 8.66098 0.811279 8.66098H6.24028C6.68833 8.66098 7.05156 9.0356 7.05156 9.49769C7.05156 9.95977 6.68833 10.3344 6.24028 10.3344ZM9.41225 13.1879C9.26098 13.1879 9.10809 13.1444 8.97172 13.0532C8.59573 12.8019 8.4885 12.2838 8.73232 11.8961L10.2396 9.49776L8.73232 7.09931C8.48864 6.71154 8.59588 6.19346 8.97187 5.94215C9.34771 5.69076 9.85019 5.80143 10.0939 6.1892L11.6473 8.66113H18.5758L20.1291 6.18928C20.3728 5.80143 20.8751 5.69083 21.2511 5.94215C21.6272 6.19346 21.7344 6.71154 21.4907 7.09931L19.9835 9.49776L21.4907 11.8961C21.7344 12.2838 21.6272 12.802 21.2512 13.0533C20.8751 13.3045 20.3728 13.1939 20.1291 12.8062L18.5758 10.3344H11.6472L10.0938 12.8062C9.93847 13.0533 9.67805 13.1879 9.41225 13.1879ZM6.24029 11.6664C6.68834 11.6664 7.05157 12.041 7.05157 12.5031C7.05157 12.9652 6.68834 13.3398 6.24029 13.3398H2.76183C2.31378 13.3398 1.95055 12.9652 1.95055 12.5031C1.95055 12.041 2.31378 11.6664 2.76183 11.6664H6.24029Z"
                    fill="#342DAB" />
                </svg>
                <span class="button-text-span-izlazna" style="width: 60.26px">{{
                dodaj_izlazna_text
                }}</span>
                <div class="svg-spin-wrapper-izlazna" style="display: none; width: 60.26px; justify-content: center">
                  <svg class="update-event-spin spinner-izlazna" id="add-to-izlazna" style="display: none"
                    viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                  </svg>
                </div>
              </div>
              <div :class="['button-dodijeli-komunikaciji']" @click="getAttachment()">
                <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 0V9.375H3.5L14 18.75L24.5 9.375H17.5V0H10.5ZM0 21.875V25H28V21.875H0Z"
                    fill="#342DAB" />
                </svg>

                <span class="button-text-span-izlazna" style="width: 60.26px">Preuzmi</span>
              </div>
            </div>
          </div>
          <v-row class="email-client-row">
            <v-col md="4" style="border-right: 2px solid rgba(230, 230, 230, 0.52)" class="email-list">
              <div class="single-prev-mail" v-for="(singleMail, key) in emails" :key="key"
                @click="getSingleMail(singleMail.id)">
                <div class="single-mail" @click="current = key" :class="{ current: key == current }">
                  <div class="mail-sender-email">
                    <div class="mail-row">
                      <span class="comm-label"> Sender:</span>
                      {{ singleMail.sender.emailAddress.name }}
                      <div class="attachment-icon" v-if="singleMail.hasAttachments">
                        <svg width="20" height="20" viewBox="0 0 35 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M25.043 0C22.4848 0 19.9265 1.05339 17.9703 2.95951L4.02544 16.6034C-1.34181 21.9706 -1.34181 30.6485 4.02544 36.0659C9.39269 41.4332 18.0706 41.4332 23.488 36.0659L29.7582 29.7958L26.297 26.3346L20.4783 32.0029L20.0269 32.655C16.5657 36.1161 10.9477 36.1161 7.48656 32.655C4.0756 29.244 4.17592 23.7263 7.48656 20.2651L21.4314 6.4708C23.3877 4.51451 26.6482 4.51451 28.6546 6.4708C30.6109 8.42709 30.5106 11.5371 28.6546 13.5435L16.1143 25.9334C15.6127 26.435 14.7599 26.435 14.2082 25.9334C13.7066 25.4317 13.7066 24.579 14.2082 24.0272L14.5091 23.8767L19.0738 19.1616L15.6127 15.7005L10.747 20.5661C8.33931 22.9738 8.33931 26.9366 10.747 29.3443C13.1548 31.7521 17.1175 31.8022 19.5253 29.3443L32.0656 17.105C35.9781 13.1924 35.9781 6.87209 32.0656 3.00967C30.1093 1.05339 27.6012 0.0501612 24.9928 0.0501612L25.043 0Z"
                            fill="#B8B8C1" />
                        </svg>
                      </div>


                    </div>
                    <div class="mail-row">
                      <span class="comm-label"> E-mail:</span>
                      <!-- {{singleMail['@odata.type'] != undefined && singleMail['@odata.type'].includes('#microsoft.graph.eventMessage') ? 'Event Message' : singleMail.sender.emailAddress.address.includes('O=EXCHANGELABS') ? 'Ja' : singleMail.sender.emailAddress.address }} -->
                      {{ singleMail.sender.emailAddress.address }}
                    </div>
                  </div>
                  <div class="mail-row mail-row-subject">
                    <span class="comm-label"> Naslov:</span>
                    {{ singleMail.subject }}
                  </div>
                </div>
                <v-divider></v-divider>
              </div>
              <div v-if="fetching_mails" class="center-spinner">
                <svg class="dot-spin" viewBox="0 0 50 50">
                  <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
              </div>
              <div v-if="emails.length == 0 && !fetching_mails" class="single-mail" @click="current = key">
                <div class="mail-sender-email">
                  <div class="mail-row">
                    <span class="comm-label"></span>
                  </div>
                  <div class="mail-row">
                    <span class="comm-label"></span>
                    <!-- {{singleMail['@odata.type'] != undefined && singleMail['@odata.type'].includes('#microsoft.graph.eventMessage') ? 'Event Message' : singleMail.sender.emailAddress.address.includes('O=EXCHANGELABS') ? 'Ja' : singleMail.sender.emailAddress.address }} -->
                  </div>
                </div>
                <div class="mail-row mail-row-subject">
                  <span class="comm-label"> Nema dostupnih e-mailova</span>
                  Nema dostupnih e-mailova
                </div>
              </div>
              <div @click="getEmails" class="see-more" v-if="selected_type==0 && emails.length > 0">
                <div class="see-more-wrapper">
                  <span>Prikaži više...</span>
                </div>
              </div>
            </v-col>
            <v-col md="8">
              <div class="single-mail active-content" v-if="selected_email != null && dialog" style="height: 1000">
                <!-- <iframe v-if="selected_email.body.content != ''" class="mail-content" :srcdoc="selected_email.body.content"></iframe> -->
                <div v-if="selected_email.body.content != ''" class="mail-content" v-html="selected_email.body.content"
                  @click="selected_attachment = null">
                </div>
                <div v-else>Sadržaj poruke je prazan</div>
                <div class=" mail-att-wrapp opening-radni-dokumenti">
                  <div class="inside-radni-dokumenti">
                    <div :class="listed_attachments.length > 3 ? 'row-multiple' : 'row'" :sort="false"
                      v-if="selected_email.hasAttachments">
                      <div v-for="(upFile,key) in listed_attachments" :key="key" class="attachment-hover-wrapp active"
                        @click="selected_attachment = upFile">
                        <div :class="[
                          listed_attachments.length > 3
                            ? 'radni-dokument-inside-multiple'
                            : 'radni-dokument-inside',
                          'preneseni-dokument', isActiveFile(upFile)?'active':''
                        ]">
                          <div :class="[
                            listed_attachments.length > 3
                              ? 'document-image-wrapper-multiple'
                              : 'document-image-wrapper',
                          ]">
                            <img class="preneseni-dokument-image" :src="returnFileType(upFile.name)" />
                          </div>
                          <div class="preneseni-dokument-title">
                            {{ upFile.name }}
                          </div>
                          <!-- <div
                          v-show="listed_attachments.length > 3"
                          class="remove-document-multiple"
                          v-if="is_permission_inside('delete')"
                          @click="deleteFileInSpis(upFile)"
                        >
                          <span>X</span>
                        </div> -->
                        </div>
                        <!-- <div class="attachment-act-wrapp" >
                          <div class="single-act" >
                            <div class="inside-text">Preuzmi</div>
                            <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" @click=getAttachment(key)>
                              <path d="M10.5 0V9.375H3.5L14 18.75L24.5 9.375H17.5V0H10.5ZM0 21.875V25H28V21.875H0Z"
                                fill="#B8B8C1" />
                            </svg>
                          </div>
                          <div class="single-act"  v-if="isFilePdf(upFile.name)" @click="selected_attachment = upFile">
                            <svg viewBox="0 0 25 25" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.5 14H9.875V21L19.25 10.5L9.875 0L9.875 7H0.5L0.5 14Z" fill="#B8B8C1" />
                            </svg>

                          </div>

                        </div> -->
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div v-if="fetching" class="center-spinner">
                <svg style="left:68%;" class="dot-spin" viewBox="0 0 50 50">
                  <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
              </div>
            </v-col>
            <v-divider vertical></v-divider>
          </v-row>
          <!-- <v-divider>

          </v-divider>
          <v-card-actions class="email-client-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Uploadaj
          </v-btn> -->
          <!-- </v-card-actions> -->
        </v-card>
        <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
          Nije odabran nijedan E-Mail. Molimo odaberite E-Mail koji želite dodati.
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              U redu
            </v-btn>
          </template>
        </v-snackbar>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import ms_email from "@/apiCallers/ms_email";
import { getCaseData } from "@/router/case/handler"
import gsap from "gsap";
import $ from "jquery";
export default {
  name: "emails",
  props: {
    accessToken: {
      type: String,
      required: true,
      default: null,
    },
    ulaz: {
      type: String,
      required: true,
      default: null,
    },
    izlaz: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      skip: 0,
      dialog: false,
      emails: [],
      spisi: [],
      selected_email: null,
      email_id: null,
      current: -1,
      dropSpisOpen: false,
      adding_to_ulazna: false,
      adding_to_izlazna: false,
      dodaj_spis_text: "Dodaj spisu",
      dodaj_ulazna_text: "Dodaj ulaznoj",
      dodaj_izlazna_text: "Dodaj izlaznoj",
      chosen_spis: "",
      fetching: false,
      fetching_mails: false,
      selected_type: 0,
      snackbar: false,
      snackTimeout: 5000,
      listed_attachments: [],

      selected_attachment: null,
    };
  },
  methods: {
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext];

      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
    isActiveFile(upFile) {
      if (this.selected_attachment == null)
        return false;
      else return this.selected_attachment.id == upFile.id;
    },
    isFilePdf() {
      var idx_ext = this.selected_attachment.name.split(".").length - 1;
      var extension = this.selected_attachment.name.split(".")[idx_ext];
      return extension == "pdf";
    },
    async getAttachment() {
      let tmp_att = this.selected_attachment
      //pripremanje download linka
      console.log(tmp_att);
      var raw = window.atob(tmp_att.contentBytes);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));      // pass your byte response to this constructor

      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      var newBlob = new Blob([array], {
        type: tmp_att.contentType,
      });
      var data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = tmp_att.name;
      link.click();
    },
    chooseSpis(id) {
      if (this.chosen_spis != id) {
        this.chosen_spis = id;
      } else {
        this.chosen_spis = "";
      }
    },
    openDrop() {
      gsap.to(".custom-dropdown-elements-wrapper", 0, { display: "block" });
      gsap.fromTo(
        ".custom-dropdown-elements-wrapper",
        0.5,
        { y: -10 },
        { y: 0, opacity: 1 }
      );
    },
    closeDrop() {
      let tl = gsap.timeline();
      tl.to(".custom-dropdown-elements-wrapper", 0.5, { y: -10, opacity: 0 });
      tl.to(".custom-dropdown-elements-wrapper", 0, { display: "none" });
    },
    openSpisDrop() {
      this.dropSpisOpen = !this.dropSpisOpen;
      if (this.dropSpisOpen) {
        this.openDrop();
      } else {
        this.closeDrop();
      }
    },
    async addToSpis() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        var tl = gsap.timeline();
        gsap.to(".svg-spin-wrapper-spis", 0, { display: "flex" });
        gsap.to(".button-text-span-spis", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-spis", 0, { display: "block", opacity: 1 });
        this.closeDrop();

        //ANIMACIJA DODAVANJA
        //umjesto ovog timeouta zvati neku async funkciju za dodavanje
        //u spis i u .then() kopirati sve kaj je u timeoutu

        await ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.chosen_spis,
            this.selected_email
          ).then(() => {
            this.dodaj_spis_text = "Dodano";
          })
          .catch(() => {
            this.dodaj_spis_text = "Greška!";
          })
          .finally(() => {
            //resetiraj postavke i animiraj na pocetak
            this.chosen_spis = "";
            gsap.to("#add-to-spis", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-spis", 0, { display: "none" });

            gsap.to(".button-text-span-spis", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_spis_text = "Dodaj spisu";
              this.dropSpisOpen = false;
              this.$emit("refresh-view", true);
            }, 1200);
          })
      }
    },

    async addAttachmentToSpis() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        // var tl = gsap.timeline();
        // gsap.to(".svg-spin-wrapper-spis", 0, { display: "flex" });
        // gsap.to(".button-text-span-spis", 0, { display: "none", opacity: 0 });
        // gsap.to("#add-to-spis", 0, { display: "block", opacity: 1 });
        // this.closeDrop();

        //ANIMACIJA DODAVANJA
        //umjesto ovog timeouta zvati neku async funkciju za dodavanje
        //u spis i u .then() kopirati sve kaj je u timeoutu

        await ms_email
          .saveEmailAttachment(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.chosen_spis,
            this.selected_attachment
          ).then(() => {
            this.dodaj_spis_text = "Dodano";
          })
          .catch(() => {
            this.dodaj_spis_text = "Greška!";
          })
          .finally(() => {
            this.selected_attachment = null;
            //resetiraj postavke i animiraj na pocetak
            this.chosen_spis = "";
            gsap.to("#add-to-spis", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-spis", 0, { display: "none" });

            gsap.to(".button-text-span-spis", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_spis_text = "Dodaj spisu";
              this.dropSpisOpen = false;
              this.$emit("refresh-view", true);
            }, 1200);
          })
      }
    },
    getEmails() {
      this.fetching_mails = true;
      let group_url = this.$route.params.uid;
      if (this.selected_type == 0 || this.spisi.length == 0)
        group_url = null;
      // console.log(this.email.length, "tu je duljina")

      console.log(group_url, "Traže se mailovi")

      ms_email.getAll(this.accessToken, this.skip, group_url).then((response) => {
        this.fetching_mails = false;
        this.emails = this.emails.concat(response.data);
        this.skip += 21
      });
    },
    getSingleMail(idMail) {
      this.selected_attachment = null;
      this.listed_attachments = [];
      this.selected_email = null;
      this.fetching = true;
      this.email_id = idMail;
      ms_email.getById(this.accessToken, idMail).then((response) => {
        this.fetching = false
        this.selected_email = response.data.message;
        this.listed_attachments = response.data.final_attachments;
      });
    },
    inMailToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_ulazna = true;
        var tl = gsap.timeline();
        gsap.to(".svg-spin-wrapper-ulazna", 0, { display: "flex" });
        gsap.to(".button-text-span-ulazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-ulazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.ulaz,
            this.selected_email
          )
          .then(() => {
            this.dodaj_ulazna_text = "Dodano";
          })
          .catch((err) => {
            this.dodaj_ulazna_text = "Greška!";
            console.log(err);
          })
          .finally(() => {
            gsap.to("#add-to-ulazna", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-ulazna", 0, { display: "none" });

            gsap.to(".button-text-span-ulazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_ulazna_text = "Dodaj ulaznoj";
              this.adding_to_ulazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    inAttachmentToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_ulazna = true;
        var tl = gsap.timeline();
        gsap.to(".svg-spin-wrapper-ulazna", 0, { display: "flex" });
        gsap.to(".button-text-span-ulazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-ulazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        ms_email
          .saveEmailAttachment(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.ulaz,
            this.selected_attachment
          )
          .then(() => {
            this.dodaj_ulazna_text = "Dodano";
          })
          .catch((err) => {
            this.dodaj_ulazna_text = "Greška!";
            console.log(err);
          })
          .finally(() => {
            this.selected_attachment = null;
            gsap.to("#add-to-ulazna", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-ulazna", 0, { display: "none" });

            gsap.to(".button-text-span-ulazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_ulazna_text = "Dodaj ulaznoj";
              this.adding_to_ulazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    outMailToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_izlazna = true;
        var tl = gsap.timeline();
        gsap.to(".svg-spin-wrapper-izlazna", 0, { display: "flex" });
        gsap.to(".button-text-span-izlazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-izlazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        ms_email
          .saveEmail(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.izlaz,
            this.selected_email
          )
          .then(() => {
            this.dodaj_izlazna_text = "Dodano";
          })
          .catch((err) => {
            this.dodaj_izlazna_text = "Greška!";
            console.log(err)
          })
          .finally(() => {
            gsap.to("#add-to-izlazna", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-izlazna", 0, { display: "none" });

            gsap.to(".button-text-span-izlazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_izlazna_text = "Dodaj izlaznoj";
              this.adding_to_izlazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    outAttachmentToPDF() {
      this.snackbar = false;
      if (this.selected_email == null) {
        this.snackbar = true;
      } else {
        this.adding_to_izlazna = true;
        var tl = gsap.timeline();
        gsap.to(".svg-spin-wrapper-izlazna", 0, { display: "flex" });
        gsap.to(".button-text-span-izlazna", 0, { display: "none", opacity: 0 });
        gsap.to("#add-to-izlazna", 0, { display: "block", opacity: 1 });
        //umjesto ovog timeouta postaviti zvati neku funkciju za dodavanje
        //u spis i u then kopirati sve kaj je u timeoutu
        ms_email
          .saveEmailAttachment(
            this.accessToken,
            this.email_id,
            this.$route.params.uid,
            this.izlaz,
            this.selected_attachment
          )
          .then(() => {
            this.dodaj_izlazna_text = "Dodano";
          })
          .catch((err) => {
            this.dodaj_izlazna_text = "Greška!";
            console.log(err)
          })
          .finally(() => {
            this.selected_attachment = null;
            gsap.to("#add-to-izlazna", 0, { display: "none", opacity: 0 });
            gsap.to(".svg-spin-wrapper-izlazna", 0, { display: "none" });

            gsap.to(".button-text-span-izlazna", 0.3, {
              display: "block",
              opacity: 1,
            });
            setTimeout(() => {
              this.dodaj_izlazna_text = "Dodaj izlaznoj";
              this.adding_to_izlazna = false;
              this.$emit("refresh-view", true);
            }, 1200);
          });
      }
    },
    //JEBENO SMECE OD VUETIFYJA
    //NEBRE POSTAVITI KLASU NA TAJ USRANI V-DIALOG PA MORA NA OVAJ MUTAVI NACIN
    addFuckingClass() {
      setTimeout(() => {
        var getFuckingParent = document.getElementById("email-catcher");
        $(getFuckingParent.parentElement.parentElement).addClass("email-popup");
      }, 100);
    },
  },
  watch: {
    selected_type: function () {
      this.skip = 0;
      this.emails = [];
      this.selected_email = null;
      this.email_id = null;
      this.current = -1;
      this.getEmails();
    }
  },
  async created() {
    await getCaseData(this.$route.params.uid).then(async (response) => {
      let all_together = response

      all_together.spis.map((spis) =>
        this.spisi.push({ naziv: spis.ime, id: spis.id_spis })
      );
    });
  },
  mounted() {
    this.getEmails();
  },

};
</script>